module.exports = __webpack_public_path__ + "img/04-1-1技术能力.9eb33424.svg";